<script setup>
import { nextTick, onMounted, onBeforeUnmount } from 'vue';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { tourRegistry } from '@/tours/tourState';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  steps: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Object,
    default: () => ({}),
  },
});

let driverInstance = null;

function transformSteps(steps) {
  return steps.map((step) => ({
    element: step.target,
    popover: {
      title: step.header?.title || '',
      description: step.content || '',
      side: step.params?.placement || 'bottom',
      align: 'start',
    },
    onHighlightStarted: async (element, stepConfig, options) => {
      if (typeof step.before === 'function') {
        await step.before('next');
        await nextTick();
      }
    },
  }));
}

function startTour(startIndex = 0) {
  // Destroy any prior active tour before creating a new one
  if (driverInstance) {
    driverInstance.destroy();
  }

  driverInstance = driver({
    animate: true,
    smoothScroll: false,
    showProgress: true,
    steps: transformSteps(props.steps),
    ...props.options,
    onDestroyed: (element, step, options) => {
      if (typeof props.options?.onDestroyed === 'function') {
        props.options.onDestroyed(element, step, options);
      }
      driverInstance = null;
    }
  });

  driverInstance.drive(startIndex);
}

onMounted(() => {
  tourRegistry[props.name] = {
    start: (startIndex = 0) => startTour(startIndex),
    stop: () => {
      if (driverInstance) {
        driverInstance.destroy();
        driverInstance = null;
      }
    },
  };
});

onBeforeUnmount(() => {
  // Called cleanly on unmount
  if (driverInstance) {
    driverInstance.destroy();
    driverInstance = null;
  }
  delete tourRegistry[props.name];
});
</script>

<template>
  <template />
</template>